import { useMemo } from 'react';
import { useGetBankQuery } from '../../../../api/queries/getBank';
import { useListBanksQuery } from '../../../../api/queries/listBanks';
import { useCompany } from '../../../../components/contexts/CompanyContextManager';

export const useBankDetailFromOption = (bankId: string) => {
    const { data } = useGetBankQuery({
        variables: {
            id: bankId,
        },
        skip: !bankId,
    });

    return useMemo(() => data?.bank, [data]);
};

const useBankOptions = () => {
    const company = useCompany(true);

    const { data } = useListBanksQuery({
        fetchPolicy: 'cache-and-network',
        variables: { filter: { companyId: company?.id } },
    });

    return useMemo(() => {
        const items = data?.list?.items || [];

        return {
            items,
            options: items.map(bank => ({
                label: company?.id ? bank.displayName : `${bank.displayName} (${bank.module?.company?.displayName})`,
                value: bank.id,
            })),
            availableFinanceProductTypesByBankId: Object.fromEntries(
                items.map(({ id, availableFinanceProductTypes }) => [id, availableFinanceProductTypes])
            ),
            moduleIdByBankId: Object.fromEntries(items.map(({ id, module }) => [id, module.id])),
        };
    }, [data, company?.id]);
};

export default useBankOptions;
